import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickAwayListener } from '@mui/base';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CachedIcon from '@mui/icons-material/Cached';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Backdrop, Box, ButtonGroup, Popper } from '@mui/material';
import React from 'react';
import { OfflineButton } from '../components';
import { Button } from '../components/Button';
export const PortalSwitchButton = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openPopper = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        handleOpen();
    };
    const closePopper = () => {
        setAnchorEl(null);
    };
    const [backdropOpen, setBackdropOpen] = React.useState(false);
    const handleClose = () => {
        setBackdropOpen(false);
        closePopper();
    };
    const handleOpen = () => {
        setBackdropOpen(true);
    };
    const isPopperOpen = Boolean(anchorEl);
    const id = isPopperOpen ? 'simple-popper' : undefined;
    return (_jsx(ClickAwayListener, { onClickAway: closePopper, children: _jsxs(ButtonGroup, { variant: "contained", sx: { boxShadow: 'none' }, children: [_jsx(OfflineButton, { variant: "contained", color: "primary", sx: {
                        width: '12rem',
                        marginTop: '8px',
                        marginBottom: '8px',
                        marginLeft: '16px',
                        marginRight: '1px',
                        cursor: 'default',
                        pointerEvents: 'none',
                    }, text: props.text }), _jsx(OfflineButton, { "data-testid": "switch-menu", variant: "contained", color: "primary", "aria-describedby": id, onClick: openPopper, sx: { marginTop: '8px', marginBottom: '8px' }, text: _jsx(ArrowDropDownIcon, {}) }, props.buttonKey), _jsx(Backdrop, { sx: { backdropFilter: 'blur(0)', zIndex: (theme) => theme.zIndex.drawer + 1 }, open: backdropOpen, onClick: handleClose, children: _jsx(Popper, { id: id, open: isPopperOpen, anchorEl: anchorEl, sx: { zIndex: (theme) => theme.zIndex.drawer + 1 }, placement: "bottom-end", children: _jsx(Box, { sx: {
                                borderRadius: '3px',
                                marginTop: '5px',
                                bgcolor: 'background.paper',
                                padding: '10px',
                            }, children: _jsxs(Button
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            , { 
                                // eslint-disable-next-line @typescript-eslint/no-empty-function
                                onClick: props.onClick, variant: "outlined", isLoading: false, "data-testid": "switch-button", children: [props.isManager ? _jsx(CachedIcon, {}) : _jsx(PersonAddIcon, {}), _jsx(Box, { sx: { marginLeft: '5px' }, children: props.switchToText })] }) }) }) })] }) }));
};
